module.exports = __webpack_public_path__ + "static/media/seamless.a50b6b48.png";